import { render, staticRenderFns } from "./User.Transactions.vue?vue&type=template&id=60f8dd23&scoped=true&"
import script from "./User.Transactions.vue?vue&type=script&lang=js&"
export * from "./User.Transactions.vue?vue&type=script&lang=js&"
import style0 from "./User.Transactions.vue?vue&type=style&index=0&id=60f8dd23&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f8dd23",
  null
  
)

export default component.exports